module.exports = __webpack_public_path__ + "img/estudiante2 1.9e737498.jpg";